
const initailState = {
    arr:[],
    nextKey:''
}
const AccountsCollectionDrivers=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_COLLECTION_DRIVER_DATA':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.nextKey
            }
        default:
            return state;
    }
}

export default AccountsCollectionDrivers